module.exports = __webpack_public_path__ + "static/media/843eccaa1a42b8fbe80e2c2e145fa0bf.843eccaa.webp";